<template>
  <div id="users" class="wrrapper">
    <page-heading title="Users">
      <template #content>
        <div class="flex align-center">
          <Button
            className="button--primary add-user mr-1"
            title="Add User"
            :onClick="addUser"
          ></Button>
          <Select
            :options="filterUsers"
            :placeholder="'Filter by'"
            :input="sortUsers"
          />
        </div>
      </template>
    </page-heading>
    <data-table
      :cols="columns"
      :rows="employeesList"
      :options="options"
      :pagination="listEmployees.length > 0"
      :totalPages="getPagination.total_pages"
      :resultCount="getPagination.total"
      :itemsPerPage="getPagination.page_size"
      :currentPage="getPagination.page_no"
      :onPageChanged="pageChanged"
      :loading="loading"
    >
      <template slot="action" slot-scope="{ actions }">
        <dropdown-menu
          :rowData="actions"
          :handleItemClick="handleItems"
          :items="items"
        />
      </template>
    </data-table>
    <Create />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import Button from "@/components/Button";
import Select from "@/components/Select";
import Create from "./create";
import { mapActions, mapGetters } from "vuex";
import { status } from "@/utils/helpers";
import { permissionsMiddleWare } from "../../utils/permissionsMiddleWare";
export default {
  components: {
    DataTable,
    DropdownMenu,
    Button,
    Select,
    Create
  },
  data() {
    return {
      items: ["Details", "Delete", "Active", "Deactive"],
      sortBy: ["name", "email", "number", "status"],
      columns: [
        { column: "serial", label: "#", width: 60 },
        { column: "full_name", label: "Name", sortable: true },
        { column: "user_name", label: "Username", sortable: true },
        { column: "email", label: "Email", sortable: true },
        { column: "roleName", label: "Role", sortable: true, sort: true },
        { column: "mobile_no", label: "Phone Number", sortable: true },
        {
          column: "twoFactorAuthEnabled",
          label: "Two Fector Authentication",
          sortable: true
        },
        { column: "status", label: "Status", userStatus: true, sortable: true },
        {
          column: "branch_name",
          label: "Branch Name",
          userStatus: true,
          sortable: true
        },
        { column: "action", label: "Action" }
      ],
      options: {
        action: true
      }
    };
  },
  methods: {
    ...mapActions({
      getEmployees: "user/getEmployees",
      deleteUser: "user/deleteUser",
      filterEmployees: "user/filterEmployees",
      doctorList: "doctors/doctorList",
      setStatus: "user/setStatus"
    }),
    handleItems(item, rowData) {
      if (item == "Details") {
        this.$router.push({ name: "User", params: { id: rowData.id } });
      } else if (item == "Delete") {
        this.deleteUser(rowData.id);
      } else if (status(item)) {
        const payload = {
          status: status(item)
        };
        this.setStatus({ id: rowData.id, payload });
      }
    },
    sortUsers(val) {
      if (permissionsMiddleWare("Search User")) {
        if (val && val != null) {
          const sortBy = val && val.toLowerCase();
          this.filterEmployees(sortBy);
        } else {
          this.getEmployees();
        }
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action : Search User"
          )
          .goAway("3000");
      }
    },
    pageChanged(val) {
      this.getEmployees(val);
    },
    addUser() {
      if (permissionsMiddleWare("Create User")) {
        this.$modal.show("userInformations");
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action : Create User"
          )
          .goAway("3000");
      }
    }
  },
  computed: {
    ...mapGetters({
      listEmployees: "user/listEmployees",
      getPagination: "user/getPagination",
      listDoctors: "doctors/listDoctors",
      loading: "loading"
    }),
    filterUsers() {
      let items = [];
      this.listDoctors && this.listDoctors.map(item => items.push(item.name));
      return items;
    },
    employeesList() {
      // map add change the twoFactorAuthEnabled vaue, if true then it should be Enabled else Disabled - only change twoFactorAuthEnabled and use rest opreator for rest
      const items = this.listEmployees || [];
      return items.map(item => ({
        ...item,
        twoFactorAuthEnabled: item.twoFactorAuthEnabled ? "Enabled" : "Disabled"
      }));
    }
  },
  mounted() {
    this.doctorList("roles");
    this.getEmployees().then(() => {
      setTimeout(() => {
        this.$store.dispatch("auth/userLoginProgress", false);
      }, 3000);
    });
  }
};
</script>

<style>
.custom-modal {
  /* overflow-y: auto !important; */
}
.users .header .add-user {
  margin-right: 30px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--dur) var(--ease);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#users .footer {
  margin-right: 30px;
}
#users .vdp-datepicker__calendar {
  right: -60px !important;
}
</style>
